import { gql, useApolloClient } from '@apollo/client';
import {
  GetNewsletterTagsQuery,
  GetNewsletterTagsQueryVariables,
} from '__generated__/queries-web';

export const GET_SEARCH_TAGS = gql`
  query GetNewsletterTags($where: TagFilterInput, $first: UnsignedInt!) {
    tags(where: $where, first: $first) {
      id
      title
      type
    }
  }
`;

export const useSearchEnabledTagsGetter = () => {
  const client = useApolloClient();

  return ({ search }: { search: string }) =>
    client
      .query<GetNewsletterTagsQuery, GetNewsletterTagsQueryVariables>({
        query: GET_SEARCH_TAGS,
        variables: {
          first: 25,
          where: { title_contains: search || undefined },
        },
      })
      .then(({ data, errors }) => {
        if (errors?.length) {
          throw errors[0];
        }

        return data?.tags;
      });
};
